<template>
    <div class="footer__position font__roboto">Copyright © 2019-2023 Shimpei YAMADA</div>
</template>
<script>
export default {
    name: 'Footer'
}
</script>
<style scoped>
.footer__position {
    margin-left: 20px;
    margin-top: 40px;
    padding-bottom: 20px;
    font-size: 10px;
}
@media screen and (min-width: 768px) {
    .footer__position{
        margin-left: 40px;
        font-size: 13px;
    }
}
</style>